/* eslint-disable @typescript-eslint/naming-convention */
import SelectParentBusinessEntityLeaf from "./SelectParentBusinessEntityLeaf.jsx"

const SelectParentBusinessEntityLeaves = function ({businessEntities, type, selectedBusinessEntityIdSignal, selectedBusinessEntityIdsSignal, enableSubmitSignal, depth }) {

	if (!businessEntities) {
		console.log("childOrgs is undefined")
		return
	}

	let leaves = []
	for (let i = 0; i < businessEntities.length; i++) {
		leaves.push(
			<SelectParentBusinessEntityLeaf
				businessEntity={businessEntities[i]}
				type={type}
				selectedBusinessEntityIdSignal={selectedBusinessEntityIdSignal}
				selectedBusinessEntityIdsSignal={selectedBusinessEntityIdsSignal}
				depth={depth}
				enableSubmitSignal={enableSubmitSignal}
				key={businessEntities[i].id}
			/>
		)
	}
	return leaves
}
export default SelectParentBusinessEntityLeaves